import priceFormatter from "@/utility/priceFormatter";
import Vue from "vue";
export default Vue.extend({
    props: {
        items: [],
    },
    data() {
        return {
            salaryHeaders: [
                {
                    text: "Director Approved",
                    value: "approvedDirector",
                    align: "center",
                    width: 70,
                    sortable: false,
                },
                {
                    text: "Manager Approved",
                    value: "approvedManager",
                    align: "center",
                    width: 70,
                    sortable: false,
                },
                // { text: "Salary type", value: "" },
                // { text: "Team", value: "" },
                { text: "Name", value: "fullName" },
                { text: "Fixed salary", value: "fixedPayment", align: "right" },
                { text: "Variable salary", value: "variablePayment", align: "right" },
                { text: "Additions", value: "additions", align: "right", width: 120 },
                { text: "Salary summary", value: "totalSalary", align: "right" },
                { sortable: false },
                { text: "Payout date", value: "expectedPaymentDate", width: 140 },
                { text: "Action", value: "action", width: 70, sortable: false },
            ],
        };
    },
    filters: {
        numberToSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK();
        },
        toShortDate(date) {
            if (date) {
                return date.split("T")[0];
            }
        },
    },
    methods: {
        sumField(key, items) {
            // sum data in give key (property)
            return items.reduce((a, b) => a + (b[key] || 0), 0);
        },
        testing(foo, bar) {
            console.log(foo, bar);
        },
    },
});
